import { Link } from "react-router-dom";
import { products } from "@/data/products";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-moss-700/60 bg-moss-900">
    <div className="mx-auto grid max-w-[1600px] gap-16 px-6 py-24 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <div className="flex items-center gap-4">
          <span className="block h-14 w-14 overflow-hidden border border-moss-700">
            <img src="/logo.webp" alt="Faeloria Collective logo" className="h-full w-full object-cover" />
          </span>
          <p className="font-serif text-3xl italic text-ivory">Faeloria Collective</p>
        </div>
        <p className="mt-8 max-w-sm text-sm leading-relaxed text-sand">
          A herbal collective crafting traditional herbal formulations.
        </p>
      </div>

      <div className="lg:col-span-3">
        <p className="text-xs uppercase tracking-[0.3em] text-gilt">The Collection</p>
        <ul className="mt-6 space-y-3">
          {products.map((p) => (
            <li key={p.slug}>
              <Link
                data-testid={`footer-link-${p.slug}`}
                to={`/collection/${p.slug}`}
                className="text-sm text-sand transition-colors duration-300 hover:text-ivory"
              >
                {p.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-4">
        <p className="text-xs uppercase tracking-[0.3em] text-gilt">Explore</p>
        <ul className="mt-6 space-y-3">
          <li><Link data-testid="footer-link-about" to="/about" className="text-sm text-sand transition-colors duration-300 hover:text-ivory">Rituals & Philosophy</Link></li>
          <li><Link data-testid="footer-link-info" to="/info" className="text-sm text-sand transition-colors duration-300 hover:text-ivory">The Herbal Index</Link></li>
        </ul>
        <p data-testid="footer-disclaimer" className="mt-10 border border-moss-700 p-5 text-xs leading-relaxed text-sand/80">
          Traditional herbal uses are described for general wellness and educational purposes only.
          These products are not intended to diagnose, treat, cure, or prevent any disease.
        </p>
      </div>
    </div>
    <div className="border-t border-moss-700/60 px-6 py-6 lg:px-12">
      <p className="mx-auto max-w-[1600px] text-xs tracking-widest text-sand/50 uppercase">
        © {new Date().getFullYear()} Faeloria Collective · Rooted in tradition
      </p>
    </div>
  </footer>
);

export default Footer;
